<template>
  <div>
    <div class="text-right mb-3">
      <button class="btn btn-primary mr-3" v-on:click="uiAdd">
        Add
      </button>
      <button class="btn btn-warning mr-3" v-on:click="uiDelete">
        Delete
      </button>
    </div>
    <div ref="table"></div>
  </div>
</template>

<script>
// https://alligator.io/vuejs/vue-cloud-firestore/
import { db } from "./main";
import Tabulator from "tabulator-tables";
import "tabulator-tables/dist/css/bootstrap/tabulator_bootstrap4.min.css";
import dateformat from "dateformat";
import chrono from "chrono-node";
import normalizeUrl from "normalize-url";

export default {
  name: "Items",
  data() {
    return {
      items: []
    };
  },
  watch: {
    items: {
      handler: function(newData) {
        this.tabulator && this.tabulator.replaceData(newData);
      },
      deep: true
    }
  },
  firestore() {
    return {
      items: db ? db.collection("items") : []
    };
  },
  methods: {
    uiAdd: function() {
      db.collection("items")
        .doc()
        .set({ title: "", description: "", link: "", start: "", stop: "" });
    },
    uiDelete: function() {
      const sel = this.tabulator.getSelectedData();
      const key = sel ? sel[0][".key"] : null;
      if (key) {
        db.collection("items")
          .doc(key)
          .delete();
      }
    }
  },
  mounted() {
    const dateFormatter = function(cell) {
      try {
        const v = cell.getValue();
        return v && dateformat(v, "ddd, mmm d");
      } catch {
        return "";
      }
    };
    const guessDate = function(input) {
      return dateformat(chrono.parseDate(input), "isoDateTime");
    };
    const removeEmpty = obj => {
      Object.keys(obj).forEach(key => obj[key] == null && delete obj[key]);
    };
    const cellEdited = function(cell) {
      const row = cell.getRow().getData();
      const key = row[".key"];
      // parse dates
      row["stop"] = row["stop"] ? guessDate(row["stop"]) : "";
      row["start"] = guessDate(row["start"]);
      if (row["stop"] <= row["start"]) {
        row["stop"] = null;
      }
      // fix url
      row["link"] = row["link"] ? normalizeUrl(row["link"]) : "";
      removeEmpty(row);
      db.collection("items")
        .doc(key)
        .set(row);
    };
    this.tabulator = new Tabulator(this.$refs.table, {
      data: this.items,
      layout: "fitDataFill",
      responsiveLayout: "collapse",
      selectable: 1,
      cellEdited,
      initialSort: [{ column: "title", dir: "asc" }],
      columns: [
        { title: "Title", field: "title", editor: "input" },
        {
          title: "Description",
          field: "description",
          formatter: "textarea",
          editor: "textarea",
          width: 500
        },
        {
          title: "Link",
          field: "link",
          formatter: "link",
          editor: "input",
          width: 200
        },
        {
          title: "Start",
          field: "start",
          formatter: dateFormatter,
          editor: "input"
        },
        {
          title: "Stop",
          field: "stop",
          formatter: dateFormatter,
          editor: "input"
        }
      ]
    });
  }
};
</script>
